import { SponsorType } from "./sponsor-type.enum";

export class SponsorList {
    name: string;
    company: string;
    requestReceipt: boolean;
    amount: number;
    type: SponsorType;
    notes: string;
}
